import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SignupRoutingModule } from './signup-routing.module';
import { OrganizationTypeSelectionModule } from './components/signup-form/components/organization-type-selection/organization-type-selection.module';
import { SignupFormModule } from './components/signup-form';
import { SignupVerifyEmailModule } from './components/verify-email/verify-email.module';
import { SignupVerifiedEmailModule } from './components/verified-email/verified-email.module';
import { SignupReferralStatusModule } from './referral/referral-status/referral-status.module';
import { SignupErrorModule } from './components/signup-error/signup-error.module';
import { SignupCompletedModule } from './components/signup-completed/singup-completed.module';
import { SignupFinishModule } from './components/signup-finish/singup-finish.module';
import { SignupInviteModule } from './invite/invite.module';

@NgModule({
    imports: [
        RouterModule,
        SignupRoutingModule,
        OrganizationTypeSelectionModule,
        SignupFormModule,
        SignupVerifyEmailModule,
        SignupVerifiedEmailModule,
        SignupReferralStatusModule,
        SignupCompletedModule,
        SignupFinishModule,
        SignupErrorModule,
        SignupInviteModule
    ]
})
export class SignupModule {}
